import Vue from 'vue'

export default {
    list() {
        return Vue.axios.get(`/order-types`)
    },
    refresh() {
        return Vue.axios.get(`/order-types/refresh`)
    },
}
